import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import Edit from "./Edit";
import SubscribersEvent from "./Subscribers";

const MainEdit = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/events/items/:id" component={Edit} />
        <Route
          path="/admin/events/items/:id/subscribers"
          component={SubscribersEvent}
        />
      </Switch>
    </Router>
  );
};
export default MainEdit;
